import { ThemeUICSSObject } from 'theme-ui';
import { captcha } from './captcha';
/* IMPORT HERE */

export const forms: ThemeUICSSObject = {
  captcha,
  /* PREPEND HERE */
};
